<template>
  <v-container>
      <v-flex>
        <v-card>
          <v-tabs
            class="tableTabs"
            slider-color="primary"
            light
            color="grey lighten-4"
            card
          >
            <v-tab>
              <img class="navIcons" src="@/assets/img/icons/block.png" alt="block" />
              &nbsp;Block
            </v-tab>
            <v-tab-item>
              <Block v-bind:block="block" :isLoading="isLoading"/>
            </v-tab-item>
            <!-- v-tab v-if="totalBlockTransactions && totalBlockTransactions == 1">
              Block Transaction ({{ totalBlockTransactions }} txn)
            </v-tab>
            <v-tab v-else-if="totalBlockTransactions && totalBlockTransactions !== 1">
              Block Transactions ({{ totalBlockTransactions }} txns)
            </v-tab>
            <v-tab-item>
              <BlockTransactionsCard v-bind:number="block.number"/>
            </v-tab-item -->
          </v-tabs>
        </v-card>
      </v-flex>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Block from './block.vue';
import BlockTransactionsCard from './blockTransactions.vue';

export default {
  name: 'BlockContainer',
  computed: {
    ...mapGetters([
      'block',
      'totalBlockTransactions',
    ]),
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    '$route.params.blockNumber': function (newNumber, oldNumber) {
      this.fetchData(newNumber);
    },
    block() {
      this.isLoading = false;
    },
  },
  created() {
    this.fetchData(this.$route.params.blockNumber);
  },
  methods: {
    fetchData(number) {
      this.isLoading = true;
      this.$store.dispatch('submitQuery', { query: number, type: 'block' });
    },
  },
  components: {
    Block,
    BlockTransactionsCard,
  },
};

</script>
